import { render, staticRenderFns } from "./ServerManage.vue?vue&type=template&id=19ce6f14&"
import script from "./ServerManage.vue?vue&type=script&lang=js&"
export * from "./ServerManage.vue?vue&type=script&lang=js&"
import style0 from "./ServerManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports